import defaultState from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const hailStateV2 = {
  namespaced: true,
  state: {
    ...defaultState,
  },
  getters,
  mutations,
  actions,
}

export default hailStateV2



// WEBPACK FOOTER //
// ./src/store/hailStateV2/index.js